/*global TPBS:false */
'use strict';

window.TPBS = (function(){
    var TPBS_common = require('../components/common');
    var TPBS_header = require('../components/header');
    var TPBS_footer = require('../components/footer');
    var TPBS_AdvSearch = require('../components/adv-search');
    var TPBS_ticker = require('../components/ticker');

    /**
     * Main
     */
    var onReady = function(){

        TPBS_header.init();

        TPBS_footer.init();
        $('.whatsnews-block__list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            //fade: true,
            //swipeToSlide: true,
            asNavFor: '.whatsnews-block__pagination'
        });
        $('.whatsnews-block__pagination').slick({
            slidesToShow: 10,
            slidesToScroll: 1,
            asNavFor: '.whatsnews-block__list',
            //dots: true,
            centerMode: false,
            focusOnSelect: true,
            inifinite: false,
            arrows: false,
        });

        $('.whatsnews-block__list').on('beforeChange', function(event,slick,slide,nextSlide) {
            $('.whatsnews-block__pagination').find('.slick-slide').removeClass('slick-current').eq(nextSlide).addClass('slick-current');
        });

        TPBS_AdvSearch.init();

        TPBS_ticker.init();

    };

    /**
     * return public method
     */
    return {
        onReady: onReady,
        TPBS_common: TPBS_common,
        TPBS_header: TPBS_header,
        TPBS_footer: TPBS_footer,
        TPBS_AdvSearch: TPBS_AdvSearch
    };
})();

$(document).ready(TPBS.onReady);

// Enable Fastclick on touch devices
FastClick.attach(document.body);